import React, { useState, useEffect } from 'react'
import './search.css'
import api from '../../services/api'
import LinksBoxItem from '../linksBox/linksBoxItem'
import Select from 'react-select';

export default function Search({searchIsOpen, handleSearch, links}) {
    const apiURL = process.env.REACT_APP_API_URL

    const [layers, setLayers] = useState([])
    const [selectedLayer, setSelectedLayer] = useState({})
    const [solutions, setSolutions] = useState([])
    const [selectedSolution, setSelectedSolution] = useState({})
    const [customers, setCustomers] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState({})
    const [assets, setAssets] = useState([])

    const getLayers = async () => {
        try{
            const response = await api.get(`/layers?populate=*`)
            if(response.data){
                const layersData = response.data.data
                let layersArr = [{ value: '', label: 'Select context' }]
                layersData && layersData.map((layer) => {
                    layersArr = [...layersArr, { value: layer.id, label: layer.attributes.Name }]
                })

                setLayers(layersArr)
            }
        } catch(err) {
            console.log(err)
        }
    }

    const getSolutions = async () => {
        try{
            const response = await api.get(`/solutions?sort=Name&populate=*`)
            if(response.data){
                const solutionsData = response.data.data
                let solutionsArr = [{ value: '', label: 'Select solution' }]
                solutionsData && solutionsData.map((solution) => {
                    solutionsArr = [...solutionsArr, { value: solution.id, label: solution.attributes.Name }]
                })

                setSolutions(solutionsArr)
            }
        } catch(err) {
            console.log(err)
        }
    }

    const getCustomers = async () => {
        try{
            const response = await api.get(`/customers?sort=Name&populate=*`)
            if(response.data){
                const customersData = response.data.data
                let customersArr = [{ value: '', label: 'Select customer' }]
                customersData && customersData.map((customer) => {
                    customersArr = [...customersArr, { value: customer.id, label: customer.attributes.Name }]
                })

                setCustomers(customersArr)
            }
        } catch(err) {
            console.log(err)
        }
    }

    const getAssets = async () => {
        try{
            const qs = require('qs')
            const query = qs.stringify({
                populate: [
                    "Image",
                    "Video",
                    "PDF",
                    "layer",
                    "solution",
                    "customer",
                    "Subtitles",
                    "Subtitles.VTT",
                ],
                filters: {
                    $and: [
                        selectedLayer,
                        selectedSolution,
                        selectedCustomer,
                    ],
                },
                sort: ['Order'],
                pagination: {
                    pageSize: 100
                }
            }, {
                encodeValuesOnly: true,
            })

            const response = await api.get(`/assets?${query}`)
            response.data && setAssets(response.data.data)
        } catch(err) {
            console.log(err)
        }
    }

    const handleLayers = (e) => {
        if(e.value !== ""){
           setSelectedLayer({
                    layer: {
                        id: {
                            $eq: e.value,
                        },
                    },
            })
        }
        else setSelectedLayer({})
    }

    const handleSolutions = (e) => {
        if(e.value !== ""){
           setSelectedSolution({
                    solution: {
                        id: {
                            $eq: e.value,
                        },
                    },
            })
        }
        else setSelectedSolution({})
    }

    const handleCustomers = (e) => {
        if(e.value !== ""){
           setSelectedCustomer({
                    customer: {
                        id: {
                            $eq: e.value,
                        },
                    },
            })
        }
        else setSelectedCustomer({})
    }

    useEffect(() => {
        getAssets()
    }, [selectedLayer, selectedSolution, selectedCustomer])

    useEffect(() => {
        getLayers()
        getSolutions()
        getCustomers()
        getAssets()
    }, [])

    const customStyles = {
        option: (styles, state) => ({
          ...styles,
          borderBottom: '1px solid #9ff0e0',
          color: '#000',
          padding: 20,
          background: state.isSelected ? '#eee' : '#fff',
          fontFamily: "MetricHPE-Semibold",
          ':active': {
            backgroundColor: '#9ff0e0'
          },
        }),
        dropdownIndicator: () => ({
            color: '#000',
            padding: 5,
        }),
        control: () => ({
          background: '#6DE7A6',
          minWidth: 175,
          borderRadius: 5,
          display: 'flex',
          fontFamily: "MetricHPE-Semibold",
        }),
        singleValue: (styles, state) => {
          const opacity = state.isDisabled ? 0.5 : 1;
          const transition = 'opacity 300ms';
          return { ...styles, opacity, transition };
        }
      }

    return (
        searchIsOpen && (
            <div className="search">
                <button className="search__close" onClick={() => handleSearch(false)}>X</button>
                <div className="search__container">
                    <form className='filters'>
                        {
                            layers &&
                            <Select
                                defaultValue={{ value: '', label: 'Select context' }}
                                onChange={handleLayers}
                                options={layers}
                                styles={customStyles}
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        }
                        {
                            solutions &&
                            <Select
                                defaultValue={{ value: '', label: 'Select solution' }}
                                onChange={handleSolutions}
                                options={solutions}
                                styles={customStyles}
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        }
                        {
                            customers &&
                            <Select
                                defaultValue={{ value: '', label: 'Select customer' }}
                                onChange={handleCustomers}
                                options={customers}
                                styles={customStyles}
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        }
                    </form>
                    <div className="linksBox__container">
                        {assets && assets.map((asset) => {
                            const link = asset.attributes
                            const imageURL = link.Image.data ? apiURL + link.Image.data.attributes.url : ''
                            const videoURL = link.Video.data ? apiURL + link.Video.data.attributes.url : ''
                            const pdfURL = link.PDF.data ? apiURL + link.PDF.data.attributes.url : ''

                            return  <LinksBoxItem 
                                        key={asset.id.toString()}
                                        url={link.URL}
                                        image={imageURL}
                                        type={link.Type}
                                        title={link.Header}
                                        subheader={link.Subheader}
                                        video={videoURL}
                                        subtitles={link.Subtitles}
                                        pdf={pdfURL}
                                    />
                        })}
                    </div>
                </div>
            </div>
        )
    )
}